<template>
    <div class="art-cont">
        <h1 class="fs28 lh38">“星火·链网”赋能粤桂茶叶数字发展，“星农计划”助力乡村振兴</h1>
        <div class="title-info">2022-05-23</div>
        <div class="main-content">
                        <div class="article-content" style="box-sizing:border-box;margin:0px;padding:0px;border:0px;font-size:19.872px;vertical-align:top;position:relative;overflow:hidden;line-height:1.6;color:#383838;font-family:-apple-system, BlinkMacSystemFont, ">
	<article style="box-sizing:border-box;margin:0px;padding:0px;border:0px;font-size:19.872px;vertical-align:top;"><section data-type="rtext" style="box-sizing:border-box;margin:0px;padding:0px;border:0px;font-size:19.872px;vertical-align:top;">
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		5月21日下午，在澳门广西社团联合总会、澳门贸易投资促进局、中国茶叶学会、广东茶产业联盟、广西壮族自治区工业和信息化厅等单位的指导下，2022年国际茶日暨“星火·链网”赋能粤桂茶叶数字发展研讨会以线上线下联动召开。本次研讨会由广州澳新茶叶国际贸易有限公司与浪潮集团联合主办，旨在贯彻落实“推动茶产业发展，加快全产业链转型升级，强化全国茶叶流通枢纽作用，不断提升大湾区茶叶品牌的竞争力和影响力”的指示精神。两广及澳门各地结合大数据应用，推出一系列措施，引导茶产业全产业链从管理决策、科学生产、数字服务、品牌营销等维度构建茶业全产业链数字化生态，推动茶产业持续健康高质量发展。引进大数据技术能够积极协助推进乡村数字化、信息化在新型乡村建设中的应用，提高茶农以及茶企的科技数字化运营水平，带动农民就业增收。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/9ef4298924b52cd1dd24ea6558970ea1.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		中共广州市荔湾区委统战部副部长陆萍，广州市荔湾区商务和投资促进局局长刘立峰，中国信息通信研究院、工业互联网与物联网研究所副所长李海花，澳门贸易投资促进局广州代表处主任钟秀立，广西壮族自治区政协委员、澳门广西社团联合总会会长徐家颕，福建省政协委员、澳门福建总商会副会长、澳门智慧人文励政会会长、首届宝船国际茶文化节“茶传播国际特别贡献奖”得奖者吴在权，广州市政协委员、澳门质量品牌国际认证联盟理事长冯文滔，中国信息通信研究院工业互联网与物联网研究所粤澳合作筹备人郝献举，浪潮工业互联网股份有限公司广州中心总经理乌苏晋，广东省岭南文化遗产研究院执行院长陈劲佟，广东省茶叶流通协会副会长、广东省传统文化促进会副会长徐靖，广西梧州六堡茶股份有限公司董事长、总经理文波，广西将军峰茶业集团有限公司总经理黄宏杰，清华珠三角研究院神农数字研发中心研发经理姚伯泉，云南西双版纳勐海源章茶叶运营中心总经理赖陈俊，百城融湾智库执行院长李丹，百城融湾智库院办主任黄秋棠，广州澳新茶业国际贸易有限公司董事长、珠海横琴融贯国际科技发展有限公司副总裁陈祥等领导参与本次会议。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/81f6f72f279ae220a040c1ac19adb1dd.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		本次会议主要分为四部分，包括：领导致辞、主题分享、签约仪式，以及参观交流。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		研讨会伊始，广西壮族自治区政协委员、澳门广西社团联合总会会长徐家颕，中国信息通信研究院工业互联网与物联网研究所副所长李海花，浪潮集团副总裁、浪潮工业互联网股份有限公司总经理庞松涛为本次活动发表了致辞。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/4337a699bf0f0391f51ccee523c7067c.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		广西壮族自治区政协委员、澳门广西社团联合总会会长徐家颕致辞时表达了非常荣幸在5.21国际茶日受邀参加此次研讨会，广西与澳门地缘相近，粤港澳大湾区的建立，港珠澳大桥通车，把桂澳两地的空间距离拉得更近了。广西乡村振兴战略实施已经取得了显著成效，茶作为自治区重点产业、支柱产业，对于数字化转型升级的需求只增不减。2021年9月，“星火·链网”在珠海横琴的骨干节点获批，将在产品标准、产业融合等方面为茶产业注入全新动能。广西是面向东盟的前沿和桥头堡，澳门衔接葡语国家经贸网络，加强澳门与广西的联系，不但有利于广西走向世界，更可拓展中国-东盟经济圈经贸合作范畴，融入葡语国家经贸网络。未来，桂、粤、澳三地联动，同时结合澳门的资源，助力广西茶叶走出国门，让世界都能尝到来自广西的好茶！澳门广西社团联合总会也将充分发挥总会的桥梁纽带作用，为开拓桂澳两地交流与合作的空间，扩大交流平台贡献力量。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/b3aeb9a3b86d1692ce877fb9f6dcef43.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		中国信息通信研究院工业互联网与物联网研究所副所长李海花表示当前新一轮科技革命和产业变革纵深推进，信息化与工业化形成历史性交汇，数字技术与工业经济融合发展大势所趋。“星火·链网”是在工业和信息化部的指导与专项支持下，由中国信通院牵头，联合北京航空航天大学、北京邮电大学、中国联通等多家大型企事业单位建设的国家区块链新型融合基础设施体系，是为持续推进产业数字化转型，推动数字资产价值化，利用区块链自主创新能力而谋划布局的数字经济“新型基础设施”。“澳优码”作为工业互联网统一标识和“星火·链网”骨干节点的重要应用在茶叶和中草药等产业中取得了许多成效。梧州六堡茶通过“澳优码”实现从种植到采摘、到加工再到交易流通，每个环节都能够确保数据可信，通过广州澳新茶叶国际贸易有限公司的贸易带动和梧州六堡茶公共茶仓的标准认证，促进了茶产业数字化转型升级，改变了原有的茶产业链的数据获取方式，对行业的发展起到了积极促进作用，希望“星火·链网”未来在粤桂茶叶产业中能够发挥更重要的作用，为产业发展保驾护航。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		随后，受邀嘉宾就“星火·链网”应用的不同领域进行主题分享。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/566303fb987b17149d321703d22f35f3.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		中国信息通信研究院工业互联网与物联网研究所粤澳合作筹备人郝献举发布了“星火·链网” 建设进展及跨境应用探索，从星火·链网建设的背景及建设内容、建设进展及成效和骨干节点跨境应用及发展前瞻三个维度为我们介绍，表示数字经济成为中国经济发展主要引擎，构建国家新型基础设施，是支撑数字经济发展的关键举措，区块链技术和产品日趋成熟，逐步沉淀为数字世界的基础设施，开放融合的体系架构，助推区块链规模化发展，“星火·链网”采用开放的建设模式，通过向接入的区块链网络提供标识基础服务进而提供跨区块链、跨区域、跨行业的互通能力，构建新时代下智能可信的价值互联网。通过双层体系架构设计及分片技术，实现区块链的性能与规模化场景的有效平衡，促进区块链的应用成效。骨干节点构建跨境应用，助力“粤澳”深合区发展。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/b2651bb407cb3746a2f79d54cabc6b16.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		广州澳新茶业国际贸易有限公司董事长、珠海横琴融贯国际科技发展有限公司总裁陈祥详细介绍了“澳优码”全面赋能数字茶叶产业的应用成果，以及通过“星农计划”提高茶农以及茶企的科技数字化运营水平，帮助茶农增收、茶企提质，促进茶产业健康高质量发展。。在标准、认证、溯源、运营、监管、信用六大体系的支持下，澳优码平台向政府和企业提供了包括品牌、服务、监管、运营在内的区域品牌服务。参考广西粤桂国际茶业交易中心和广州茶叶国际交易中心已形成的完整贸易模式，“星火·链网”及其下的澳优码应用能够有效解决后疫情时代产业的数字化升级问题，为当前澳门发展欣欣向荣的茶叶和中药产业提供定制化的数字升级服务，并发布“星农计划”正式启动。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/e262063f01758b98ac3d2b002c2b9bed.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		浪潮工业互联网股份有限公司广州中心总经理乌苏晋分享了基于“星火·链网”打造的茶青交易平台，表示现阶段主要服务于茶叶数字贸易场景，通过引入茶青等级、茶青经纪人等环节，利用区块链去中心化、数据不可篡改的技术特性，打造茶青交易平台，实现茶青采摘、运输配送和生产加工多个环节数据连接，带动21个茶叶种植区数字化转型升级，茶青采收效率提高45%，助力茶青原产地提质增收和产业链供需匹配柔性发展。下一步，浪潮云洲将重点赋能梧州六堡茶在内的广西茶产业，将产业数据接入广西工业互联网平台，助力粤桂茶产业数字化转型与高质量发展。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		由澳门质量品牌国际认证联盟、清华珠三角研究院、浪潮工业互联网、广州澳新茶业国际贸易有限公司、澳门大学中医药实验室、中国信通院，共同合作启动“茶产业数字国际贸易联合实验室”，该实验室致力于通过数字化赋能，为茶产业国际贸易提供更高质、更高量的可持续发展路径。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		现场邀请了中共广州市荔湾区委统战部副部长陆萍陆部长，澳门贸易投资促进局广州代表处主任钟秀立主任，澳门质量品牌国际认证联盟理事长冯文滔，浪潮工业互联网股份有限公司广州中心总经理乌苏晋，中国信息通信研究院工业互联网与物联网研究所粤澳合作筹备人郝献举，广州澳新茶业国际贸易有限公司董事长陈祥上台一起为“茶产业数字国际贸易联合实验室”筹备启动揭牌。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/5007128de113b90a8b62a4efd37b779d.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		通过“星火·链网”的应用，实现了对数据的收集沉淀、数据分析，并根据分析数据解决茶产业中效率和质量问题，助力茶企精准管理，提高综合效益，深度促进茶产业发展。通过数据，可以发现问题、分析问题、解决问题，打破传统的经验驱动决策的方式，实现科学决策。做好茶产品，探索数字化营销，紧跟时代发展潮流积极拥抱数字化营销，促进茶产业良性发展。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		随即进行研讨会第三个流程签约仪式，广州澳新茶业国际贸易有限公司与浪潮集团代表进行“星农计划”战略合作签约仪式。
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		<img data-alt="" src="https://rs1.huanqiucdn.cn/dp/api/files/imageDir/e62436fba962255b63b6f2d0f8eaabae.png" style="box-sizing:border-box;margin:0px;padding:0px;font-size:19.872px;vertical-align:top;width:380.906px;border-radius:0.053333rem;" ondragstart="return false">
	</p>
	<p style="box-sizing:border-box;margin-top:0px;margin-bottom:0.533333rem;padding:0px;border:0px;font-size:19.872px;vertical-align:top;letter-spacing:0.04rem;text-align:justify;">
		最后，与会嘉宾就“星火·链网”赋能粤桂茶叶数字发展问题展开了进一步探讨并参观茶交中心。
	</p>
</section></article>
</div>
<div class="editor" style="box-sizing:border-box;margin:0px;padding:0.2rem 0px;border:0px;font-size:0.373333rem;vertical-align:top;color:#383838;font-family:-apple-system, BlinkMacSystemFont, ">
	责编：张凯
</div>
                    </div>
        <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
            <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
            
        </div>
        <div class="arc-nav">
            <a href="/NewsDetail/61" ondragstart="return false">上一条 :  澳门智慧人文励政会拜访经济财政司 交流数字产业发展</a>
            <a href="/NewsDetail/59" ondragstart="return false">下一条 : “星火·链网”赋能粤桂茶叶数字发展，“星农计划”助力乡村振兴</a>
        </div>
    </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>